/**
 * EditApplicationDialog
 * Warning dialog for confirming envelope void when unlocking for editing
 */

import {
  AlertCircleIcon,
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
} from "@porchpass/ui";
import * as React from "react";

interface EditApplicationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isVoiding?: boolean;
}

export const EditApplicationDialog: React.FC<EditApplicationDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isVoiding = false,
}) => {
  const handleConfirm = () => {
    void onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertCircleIcon size={20} className="text-[#df1b41]" />
            <DialogTitle>Void Signature and Edit Application?</DialogTitle>
          </div>
        </DialogHeader>
        <DialogBody>
          <p className="text-base text-[#4a5466]">
            Voiding the signature will cancel the current signing process. A new
            signature will be needed to resubmit for signatures.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button
            onClick={() => onOpenChange(false)}
            variant="secondary"
            size="s"
            disabled={isVoiding}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isVoiding}
            loading={isVoiding}
            size="s"
          >
            {isVoiding ? "Voiding..." : "Yes, Void Signature"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
